module.exports = __webpack_public_path__ + "static/media/logottl.2b36bedb.png";